module.exports = __webpack_public_path__ + "img/28.b6e9a4b5.png";